import { customerApi } from '../../config/axios.config'

export class AuthService {
	static async login(username: string, password: string): Promise<any> {
		const response = await customerApi.post(`/auth/login/hostess`, { username, password })
		return response?.data
	}
}
